<template>
  <div class="page-container">
    <div class="query-title">生产计划汇总处理</div>

    <div class="content">
      <QueryParams ref="QueryParams" :loading="loading" :search-field="searchField" @search="queryData" />
      <div class="table-container">
        <Table-filter
          title="生产计划"
          :rt-columns="rtColumns1"
          :lt-columns="ltColumns1"
          :grid-columns="gridOptions.columns"
          :count-data="countFileds"
          :all-options="allOptions"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange1"
          @confirm="params => tableConfigConfirm(params, 'xTable')"
        >
          <template #button>
            <table-button name="export" tip="导出" @click="exportExcel('nosum')" />
            <table-button name="sum" tip="汇总" @click="summary" />
          </template>
          <vxe-grid
            ref="xTable"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            height="300"
            max-height="500"
            align="center"
            size="mini"
            show-overflow
            :checkbox-config="{ highlight: true }"
            :radio-config="{ highlight: true }"
            :sort-config="{ multiple: true }"
            :empty-render="{ name: 'NotData' }"
            :filter-config="{ remote: true }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
            :row-class-name="params => rowClassName(params, 'xTable')"
            @filter-change="evt => filterChangeEvt(evt, 'xTable')"
          />
        </Table-filter>

        <Table-filter title="汇总生产计划" :show-custome="false">
          <template #button>
            <table-button name="export" tip="导出" @click="exportExcel('sum')" />
            <table-button name="delete" tip="删除" @click="makePlanSumDetailDelete" />
            <table-button name="confirm" tip="确认" @click="makePlanSumDetailConfirm" />
          </template>
          <vxe-grid
            ref="xTable2"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            height="300"
            max-height="500"
            align="center"
            size="mini"
            show-overflow
            :checkbox-config="{ highlight: true }"
            :radio-config="{ highlight: true }"
            :sort-config="{ multiple: true }"
            :empty-render="{ name: 'NotData' }"
            :filter-config="{ remote: true }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions2.columns"
            :data="gridOptions2.data"
          >
            <template #remark="{row}">
              <el-input v-model="row.remark" size="mini" placeholder="请输入" />
            </template>
          </vxe-grid>
        </Table-filter>
      </div>
    </div>

    <table-custom-filter
      ref="CustomFilter"
      :current-filter-field="currentFilterField"
      @confirm="customeFilter"
    />
  </div>
</template>

<script>
import { apiGetProdSumHandleList, apiGetProdSumHandleSave } from '@/api/sap/make-plan'
import tableMixins from '@/utils/tableMixins'
import { pageSearch, config1, config2 } from './config/makeSumOrder'
import { frontExport, concurrencyReq } from '@/utils/frontExport'
export default {
  mixins: [tableMixins],
  data() {
    return {
      loading: false,
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      pagination2: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      gridOptions: {
        columns: [{ type: 'checkbox', title: '', field: 'checkbox' }],
        data: []
      },
      gridOptions2: {
        columns: [{ type: 'checkbox', title: '', field: 'checkbox' }],
        data: []
      },
      already: [],
      pageSearch,
      searchField: {}
    }
  },
  created() {
    this.searchField = this.pageSearch
    this.initPage(config1, 'gridOptions')
    this.initPage(config2, 'gridOptions2', false)
  },
  methods: {
    initPage(pageConfig, name = 'gridOptions', flag = true) {
      const columns = []
      // const searchField = {}
      const keys = Object.keys(pageConfig)
      keys.forEach(key => {
        const defaultFmt = { t: 's' }
        const obj = {
          field: key,
          title: pageConfig[key].title,
          width: pageConfig[key].width || 120,
          filters: [],
          filterMultiple: false,
          xlsxFmt: Object.assign(defaultFmt, pageConfig[key].xlsxFmt || {})
        }
        if (pageConfig[key].slot) {
          obj.slots = {
            default: key
          }
        }
        // 该字段展示为描述
        if (pageConfig[key].describe) {
          obj.field += '_text'
        }
        if (!flag) {
          delete obj.filters
          delete obj.filterMultiple
        }
        columns.push(obj)
      })
      this[name].columns = this[name].columns.concat(columns)
    },
    // 确认汇总
    async makePlanSumDetailConfirm() {
      await this.$confirm('是否确认汇总！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        sumitem: this.gridOptions2.data,
        item: this.gridOptions.data.filter(v => this.already.includes(v._X_ID))
      }
      const res = await apiGetProdSumHandleSave(params)
      if (res.MSGTYPE === 'S') {
        this.$message.success('汇总成功！汇总单号为 ' + res.PRODSUM_ID)

        this.queryData()
        this.gridOptions2.data = []
        this.already = []
      }
    },
    async exportExcel(type) {
      if (type === 'sum') {
        frontExport(this.gridOptions2.columns, this.gridOptions2.data, '生产计划汇总单')
      } else {
        const params = {
          user_bp: this.$store.getters.role.USER_BP,
          ...this.allConditions
        }
        const data = await concurrencyReq(this.pagination.totalCount, params, apiGetProdSumHandleList)
        frontExport(this.gridOptions.columns, data, '生产计划单')
      }
    },

    // 汇总
    async summary() {
      const checkedList = this.$refs.xTable.getCheckboxRecords()

      if (!checkedList.length) return this.$message.warning('请选择需要汇总的数据！')

      // 过滤未汇总的数据
      const noSumCode = checkedList.filter(v => !v.packsum_id && v.status === '未汇总')

      if (checkedList?.length && checkedList.length !== noSumCode.length) {
        return this.$message.success('请选择未汇总数据！')
      }

      // 有数据 进行汇总
      if (noSumCode.length) {
        this.makePlanSum(noSumCode)
      } else if (!noSumCode.length && checkedList.length) {
        this.$message.warning('请选择未汇总数据！')
      }
    },
    async makePlanSum(list) {
      // 生产计划状态改变
      list.map(item => {
        item.status = '已汇总'
      })

      // 保存已经汇总的 _X_ID
      this.already = this.already.concat(list.map(v => v._X_ID))

      // 合并相同产品的生产计划
      const sumList = [...JSON.parse(JSON.stringify(list))].concat(...this.gridOptions2.data)
      this.gridOptions2.data = sumList.reduce((pre, cur, i) => {
        delete cur._X_ID
        cur.status = '未确认'
        if (i === 0) {
          pre.push(cur)
          return pre
        }
        const item = pre.find(v => v.product_id === cur.product_id && v.version === cur.version)
        if (item) {
          item.planqty_box = (item.planqty_box - 0) + (cur.planqty_box - 0)
          item.planqty_bottle = (item.planqty_bottle - 0) + (cur.planqty_bottle - 0)
          item.planqty_ton = (item.planqty_ton - 0) + (cur.planqty_ton - 0)
          return pre
        } else {
          pre.push(cur)
          return pre
        }
      }, [])
    },
    // 删除
    async makePlanSumDetailDelete() {
      const checkedList = this.$refs.xTable2.getCheckboxRecords()
      const productIds = checkedList.map(v => v.product_id)

      // 删除汇总的明细
      checkedList.forEach(item => {
        const index = this.gridOptions2.data.findIndex(v => v._X_ID === item._X_ID)
        this.gridOptions2.data.splice(index, 1)
      })

      // 改变生产计划的状态为 未汇总
      this.gridOptions.data.map(item => {
        if (productIds.includes(item.product_id) && item.status === '已汇总') {
          item.status = '未汇总'
          const index = this.already.findIndex(v => v._X_ID === item._X_ID)
          this.already.splice(index, 1)
        }
      })
    },
    showList(row) {
      this.$router.push({
        path: '/wly/make-plan/order-edit',
        query: {
          id: row.PRODPL_ID
        }
      })
    },
    async queryData(page, ranges) {
      if (page === 1) {
        this.pagination.page = page
        if (ranges) {
          // 保存 查询组件的查询参数
          this.ranges = ranges
          this.handleRanges(ranges)
        }
        this.isSetFilter = false
      }
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        role: this.$store.getters.role.ROLE,
        ...this.allConditions,
        ...this.pagination,
        is_result: 1,
        sort: this.sortData.concat(this.tableSort)
      }

      this.loading = true
      try {
        const { data, total, calculation, field } = await apiGetProdSumHandleList(params)
        if (data.length === 0 && total - 0) {
          this.queryData(1, ranges)
          return
        }
        this.pagination.totalCount = total - 0
        this.calculation = this.filtercalculation(calculation)
        // 更新计算值
        this.updateCount()
        if (this.showHeader) {
          this.gridOptions.data = this.tableCountData.concat(data)
        } else {
          this.gridOptions.data = data.concat(this.tableCountData)
        }
        this.gridOptions2.data = []
        this.allOptions = this.filterAllOptions(field)
        this.setFilter()
      } catch (e) {
        //
      }
      this.loading = false
    },
    handleTablePaginationChange1(pages) {
      Object.assign(this.pagination, pages)
      this.queryData()
    },
    handleTablePaginationChange2(pages) {
      Object.assign(this.pagination2, pages)
      this.queryData()
    }
  }
}
</script>
<style lang="scss" scoped>
.blue {
  color: rgb(45, 146, 214);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/make-plan-manage/makeSumOrder.vue